// import intlTelInput from 'intl-tel-input';
import { isMobile } from '../utils/base-init.js'
import './fast-payment.js'
// import initJQueryValidation from '../utils/init-jquery-validation.js'
import { surveyBlockEffect, surveyBtnEffect } from '../utils/survey-btn-effect.js'
import { saveInfoToCookie } from '../components/save-info-to-cookie.js'
import detectMobileWidth from '../utils/detectMobileWidth.js'
import checkRadio from '../utils/checkRadio.ts'
import { setShippingValidationRules, setShippingBillingValidationRules, setBillingValidationRules } from './setValidationRules.ts'
import { emailValidation } from '../components/email-validation.js'

// import { finishedSurvey } from './fast-payment'


export function initFastPaymentCheckoutUI(fastPayment) {
	let fastPaymentSteps
	let _isMobile
	const isMobileWidth = detectMobileWidth()

	if (giftCardCheckout) {
		fastPaymentSteps = {
			DELIVERY: 1,
			PAYMENT: 2,
			ORDER: 3,
			SURVEY: 4
		}
	} else {
		fastPaymentSteps = {
			// EMAIL: 1,
			DELIVERY: 2,
			PAYMENT: 3,
			SURVEY: 4
		}
	}

	fastPayment.steps = []

	if (giftCardCheckout) {
		fastPayment.steps = [
			$('[fpStep="DELIVERY"]'),
			$('[fpStep="PAYMENT"]'),
			$('[fpStep="ORDER"]'),
			$('[fpStep="SURVEY"]')
		]
	} else {
		fastPayment.steps = [
			// $('[fpStep="EMAIL"]'),
			$('[fpStep="DELIVERY"]'),
			$('[fpStep="PAYMENT"]'),
			$('[fpStep="SURVEY"]')
		]
	}

	let fastPaymentMobileSteps
	if (giftCardCheckout) {
		fastPaymentMobileSteps = {
			DELIVERY1: {
				step: 2,
				page: 1
			},
			PAYMENT: {
				step: 3,
				page: 2
			}
		}
	} else {
		fastPaymentMobileSteps = {
			DELIVERY1: {
				step: 2,
				page: 1
			},
			DELIVERY2: {
				step: 2,
				page: 2
			},
			PAYMENT: {
				step: 3,
				page: 3
			}
		}
	}

	if (giftCardCheckout) {
		fastPayment.mobileSteps = [
			$('[fpStep="DELIVERY1"]'),
			$('[fpStep="PAYMENT"]')
		]
	} else {
		fastPayment.mobileSteps = [
			$('[fpStep="DELIVERY1"]'),
			$('[fpStep="DELIVERY2"]'),
			$('[fpStep="PAYMENT"]')
		]
	}

	fastPayment.curStep
	// fastPayment.maxSteps = giftCardCheckout ? 4 : 4
	fastPayment.maxSteps = detectMobileWidth() ? 3 : 4
	fastPayment.isMobile

	fastPayment.mobileCurStep = { step: 2, page: 1 }

	// fastPayment.selectYearAction

	fastPayment.updateIsMobile = function () {
		fastPayment.isMobile = detectMobileWidth()
		// _isMobile = fastPayment.isMobile
	}

	fastPayment.updateUI = function (onGoToMyStep) {
		if (onGoToMyStep == undefined) fastPayment.updateCheckOutButtons()

		if (isMobileWidth) {
			$.each(fastPayment.mobileSteps, (index, fpstep) => {
				if (index + 1 == fastPayment.curStep.page) {
					fpstep.addClass('active-level-1')
				} else {
					fpstep.removeClass('active-level-1')
					// step.hide()
				}
			})

			if (fastPayment.curStep.step == fastPaymentMobileSteps.DELIVERY1.step) {
				setShippingValidationRules()
			}

			if (fastPayment.curStep.page == fastPaymentMobileSteps.PAYMENT.page) {
				console.debug(`fastPayment.curStep.page == fastPaymentMobileSteps.PAYMENT.page: ${fastPayment.curStep.page} ${fastPaymentMobileSteps.PAYMENT.page}`)
				setShippingBillingValidationRules()
				$('.bottom-bay').hide()
				$('#order-general-bottom-buttons').show()
			} else {
				$('.bottom-bay').show()
				$('#order-general-bottom-buttons').hide()
			}
		}

		if (fastPayment.curStep == fastPaymentSteps.PAYMENT) {
			const sameAsShipping = $('#sameAsShipping').is(':checked')
			if (!giftCardCheckout && sameAsShipping) {
				copyShippingAddressToBilling()
			}
		}

		if (isMobileWidth) {
			window.scrollTo(0, 0)
		}
	}

	fastPayment.updateCheckOutButtons = function () {
		const buttons = isMobileWidth ?
			$('#check-out-bar-buttons').find('.wrapper') :
			$('#check-out-bar-buttons-v').find('.wrapper')
		const _curStep = isMobileWidth ?
			fastPayment.curStep.step :
			fastPayment.curStep
		// console.log('fastPayment.isMobile is ' + fastPayment.isMobile)
		$.each(buttons, (index, button) => {
			const step = index + 1 // index is 0-based
			const num = step == 1 ? '' : step // the number 1 font is just called 'syr-number', so no appending the step.
			$(button)
				.find('.syr-glyphs')
				.toggleClass(`syr-number${num}`, step >= _curStep)
			$(button)
				.find('.check-out-label')
				.toggleClass('success', step < _curStep)
			$(button)
				.find('.syr-glyphs')
				.toggleClass('syr-checkmark success', step < _curStep)
			$(button)
				.find('.syr-glyphs')
				.toggleClass('disabled', step !== _curStep)
			$(button)
				.find('.check-out-label')
				.toggleClass('disabled', step !== _curStep)
		})
	}

	fastPayment.goToMyStep = function () {
		// only  mobile:
		const buttons = $('#check-out-bar-buttons .mobile-step-btn').find('.syr-glyphs, .check-out-label')
		const NextBtn = document.querySelector('#fastPaymentNextButton')

		$.each(buttons, (index, button) => {
			// const step = index + 3 // index is 0-based, but mobile is from 3(Delivery)
			$(button).on('click', () => {
				fastPayment.curStep.step = index < 1 ? 2 : 3

				if (fastPayment.curStep.step == 2) {
					fastPayment.curStep.page = 1
					if ($('#fast-payment-recipient').css('display') == 'block') {
						// fastPayment.curStep.page = 2
						NextBtn.classList.replace(
							'data-page-track-delivery',
							'data-page-track-recipient'
						)
					} else {
						// fastPayment.curStep.page = 1
						NextBtn.classList.replace(
							'data-page-track-recipient',
							'data-page-track-delivery'
						)
					}
				} else {
					fastPayment.curStep.page = 2
					fastPayment.curStep.step = 2
				}
				// })

				fastPayment.updateUI(true)
				history.pushState({ step: fastPayment.curStep }, null, null)
				// callTracking(fastPayment.curStep)

				// console.info(`goToMyStep curStep.step:  ${fastPayment.curStep.step}`)
				// console.info(`goToMyStep curStep.page:  ${fastPayment.curStep.page}`)

				if (fastPayment.curStep.step == fastPaymentMobileSteps.DELIVERY1.step) {
					// callTracking(1)
					setShippingValidationRules()
				}

				if (fastPayment.curStep.step == fastPaymentMobileSteps.PAYMENT.step) {
					console.debug(`goToMyStep fastPayment.curStep.step:  ${fastPayment.curStep.step}`)
					copyShippingAddressToBilling()
					setBillingValidationRules()
					$('.bottom-bay').hide()
					$('#order-general-bottom-buttons').show()
				} else {
					$('.bottom-bay').show()
					$('#order-general-bottom-buttons').hide()
				}

				window.scrollTo(0, 0)
			})
		})
	}

	fastPayment.onNextStep = function () {
		// block next if not valid.
		if (isMobileWidth) {
			// mobile

			const NextBtn = document.querySelector('#fastPaymentNextButton')

			if (fastPayment.curStep.page >= 3) {
				return
			}


			if (!$('#order-payment-form').valid()) {
				return
			}

			if (fastPayment.curStep.step == fastPaymentMobileSteps.PAYMENT.step) {
				if (typeof stripeError !== 'undefined') {
					// if (!$('[name=cardnumber]').val() && !$('[name=exp-date]').val() && !$('[name=postal]').val()) {
					//   return
					// }
					if (stripeError) return
				}

				callTracking(fastPayment.curStep.page)
			}

			if (fastPayment.curStep.step == fastPaymentMobileSteps.DELIVERY1.step) {
				// this.curStep.step==3
				// console.info(
				// 	`fastPaymentMobileSteps.DELIVERY1-2.step: ${fastPaymentMobileSteps.DELIVERY1.step}`
				// )


				if (!checkRadio('midDelivery', document.querySelector('#select-mid-delivery-sm'))) {
					const errorBlock = document.querySelector('#mobile-delivery-error')
					if (errorBlock) errorBlock.innerHTML = window.myvars.selectDeliveryMethod
					return
				}
				NextBtn.classList.replace(
					'data-page-track-delivery',
					'data-page-track-recipient'
				)
				// if (giftCardCheckout) {
				//   setTimeout(() => {
				//     ajaxLoadcountryIdBillingList()
				//   }, 1000)
				// }

				if ($('#order-payment-form').valid()) {
					if ($('#fast-payment-recipient').css('display') === 'block') {
						if ($('#order-payment-form').valid()) {
							// if (this.curStep.page == 2) {
							fastPayment.curStep.step++
							fastPayment.curStep.page++
							fastPayment.updateUI()
							// }

							history.pushState({ step: fastPayment.curStep }, null, null)
							callTracking(fastPayment.curStep.page)
							console.info(`callTracking: ${fastPayment.curStep.page}`)
						}
					} else if ($('#order-payment-form').valid()) {
						// if (this.curStep.page == 2) {
						fastPayment.curStep.page++
						fastPayment.updateUI()
						// }

						history.pushState({ step: fastPayment.curStep }, null, null)
						callTracking(fastPayment.curStep.page)
						console.info(`callTracking: ${fastPayment.curStep.page}`)
					}
				} else {
					// $('.fast-payment-delivery-block').attr('data-level2-actived', 'false')
				}
			}
		} else {
			// desktop
			if (fastPayment.curStep >= fastPayment.maxSteps) {
				return
			}

			if (fastPayment.curStep == fastPaymentSteps.DELIVERY) {
				if (!$('#shipping-address-form-container input').valid()) {
					return
				}
			}

			if (fastPayment.curStep == fastPaymentSteps.PAYMENT) {
				if (!$('#order-fast-payment-credit-cart input').valid()) {
					return
				}
			}

			fastPayment.curStep++
			fastPayment.updateUI()
			history.pushState({ step: fastPayment.curStep }, null, null)
			callTracking(fastPayment.curStep)
			console.info(`callTracking: ${fastPayment.curStep}`)
		}
	}

	fastPayment.onPrevStep = function () {
		if (isMobileWidth) {
			if (fastPayment.curStep.page <= 1) {
				window.location.href = '/store/order/review-cart'
			}

			if (fastPayment.curStep.page == 2) {
				// fastPayment.curStep.step++
				fastPayment.curStep.page--
			} else {
				fastPayment.curStep.step--
				fastPayment.curStep.page--
			}

			fastPayment.updateUI()
		} else {
			if (fastPayment.curStep <= 1) return
			fastPayment.curStep--
			fastPayment.updateUI()
		}
	}

	fastPayment.initNextButton = function () {
		const buttonHtml = `
      <footer class="bottom-bay">
        <a id="fastPaymentNextButton" class="btn btn-primary btn-block btn--main data-page-track-delivery" href="javascript:;">${myvars.next}</a>
      </footer>
      `
		if (fastPayment.isMobile) {
			$('.panel-banner').append(buttonHtml)
		}
	}

	// monitor for media query change between desktop and mobile
	$(window).resize(() => {
		fastPayment.updateIsMobile()
		// console.log('isMobile: ' + fastPayment.isMobile)
	})

	fastPayment.surveyTriggerNavi = function () {
		if (finishedSurvey === false) {
			const surveys = $('#order-payment-form').find('.survey-item-inline input')

			$.each(surveys, (_, survey) => {
				$(survey).on('click', () => {
					setShippingBillingValidationRules()
					if ($('#order-payment-form').valid()) {
						fastPayment.curStep = 4
						fastPayment.updateUI()
					} else {
						fastPayment.curStep = 2
						fastPayment.updateUI()
					}

					finishedSurvey = true
				})
			})
		}
	}

	fastPayment.navigationStep = function () {
		if (fastPayment.isMobile) {
			$('#creditCardNumber').on('focus', () => {
				if (giftCardCheckout) {
					setBillingValidationRules()
				} else {
					setShippingBillingValidationRules()
				}
			})
		} else {
			$('#creditCardNumber').on('focus', () => {
				if (giftCardCheckout) {
					setBillingValidationRules()
				} else {
					setShippingBillingValidationRules()

					if (!$('#shipping-address-form-container input').valid()) {
						fastPayment.curStep = 2
						fastPayment.updateUI()
					} else {
						fastPayment.curStep = 3
						fastPayment.updateUI()
						// setBillingValidationRules()
					}
				}
			})
		}
	}

	fastPayment.finishPaymentStep = function () {
		setShippingBillingValidationRules()
		if (!detectMobileWidth()) {
			if (!giftCardCheckout) {
				if ($('#order-payment-form').valid()) {
					fastPayment.curStep = 3
					fastPayment.updateUI()
				} else {
					fastPayment.curStep = 2
					fastPayment.updateUI()
				}
			}
		}
	}

	fastPayment.activeNextButton = function () {
		// bind next button
		$('#fastPaymentNextButton').click(() => {
			fastPayment.onNextStep()
		})

		// bind popstate for history back button
		window.onpopstate = function (event) {
			fastPayment.onPrevStep()
		}
	}

	// first display
	fastPayment.updateIsMobile()

	fastPayment.curStep = fastPayment.isMobile ? fastPayment.mobileCurStep : 1
	fastPayment.initNextButton()
	fastPayment.updateUI()
	surveyBtnEffect()
	surveyBlockEffect()
	fastPayment.surveyTriggerNavi()
	layoutShippingAddressForm()
	fastPayment.goToMyStep()
	fastPayment.navigationStep()
	fastPayment.activeNextButton()
}

function callTracking(step) {
	switch (step) {
		case 1:
			$('#fast-payment-container').trigger('checkout:delivery')
			break
		case 2:
			$('#fast-payment-container').trigger('checkout:recipient')
			break
		case 3:
			$('#fast-payment-container').trigger('checkout:payment')
			break
		case 4:
			$('#fast-payment-container').trigger('checkout:order')
			break
		case 5:
			$('#fast-payment-container').trigger('checkout:survey')
			break
		default:
			break
	}
}

export function firstNameFocus() {
	if (!window.myvars.isHelping) {
		// if (giftCardCheckout) {
		// 	// setBillingValidationRules()
		// } else {
		// 	// setShippingBillingValidationRules()
		// 	// setShippingValidationRules()
		// }

		if (detectMobileWidth()) {
			setShippingValidationRules()

		} else if (!$('#fp-email-top').valid()) {
			// window.curStep = 1
			// window.updateUI()
		} else {
			// window.curStep = 2
			// window.updateUI()
			if (window.myvars.enableEmailValidation) {
				emailValidation($('#fp-email-top').val())
			}
		}
	}
}

function onUseShippingForBillingChecked() {
	copyShippingAddressToBilling()
	const sameAsShipping = $('#sameAsShipping').is(':checked')
	$('#billing-address-section').toggleClass('disabledElement', sameAsShipping)
	if (sameAsShipping) {
		$('input[name="addressEidBilling"]').attr('disabled', 'disabled')
	} else {
		// cleanBillingAddress()
		$('input[name="addressEidBilling"]').removeAttr('disabled')
		if (!detectMobileWidth() && !window.helpervars) {
			setShippingBillingValidationRules()
		}
	}

	// saveInfoToCookie()
}

function copyCountryState() {
	const $options = $('#stateId > option').clone()
	$('#stateIdBilling').empty().append($options).val($('#stateId').val())
}

function copyShippingAddressToBilling() {
	$('#firstNameBilling').val($('#firstName').val())
	$('#lastNameBilling').val($('#lastName').val())
	if (
		$('#firstNameKatakanaBilling').length &&
		$('#shippingFirstNameKatakana').length
	) {
		$('#firstNameKatakanaBilling').val($('#firstNameKatakana').val())
	}

	if (
		$('#lastNameKatakanaBilling').length &&
		$('#shippingLastNameKatakana').length
	) {
		$('#lastNameKatakanaBilling').val($('#lastNameKatakana').val())
	}

	$('#address1Billing').val($('#address1').val())
	$('#address2Billing').val($('#address2').val())
	$('#countryIdBilling').val($('#countryId').val())
	copyCountryState()
	// $('#stateIdBilling').val($('#stateId').val())
	$('#zipBilling').val($('#zip').val())
	if ($('#zip2Billing').length && $('#zip2').length) {
		$('#zip2Billing').val($('#zip2').val())
	}

	$('#cityBilling').val($('#city').val())
	$('#phoneBilling').val($('#phone').val())
	if (
		window.phoneCountryCodeBilling &&
		window.itiBilling &&
		window.iti &&
		window.iti.getSelectedCountry()
	) {
		console.debug(
			'set country for billing phone',
			window.iti.getSelectedCountry().iso2,
		)
		window.itiBilling.setSelectedCountry(window.iti.getSelectedCountry().iso2)
	}

	if ($('#emailBilling').val() === '') {
		if (detectMobileWidth()) {
			// $('#emailBilling').val($('#email').val())
		} else {
			$('#emailBilling').val($('#fp-email-top').val().replace(/\+/g, '%2B'))
		}
	}

}

function layoutShippingAddressForm() {
	$('#shippingAddressCountryContainer').append($('select#countryId'))
	$('#shippingAddressStateContainer').append($('select#stateId'))
	$('#shippingAddressEmailContainer').append(
		$('#shipping-address-form-container input#shipping-email')
	)

	// for billing form
	$('#billingAddressCountryContainer').append($('select#countryIdBilling'))
	$('#billingAddressStateContainer').append($('select#stateIdBilling'))
}



window.setShippingValidationRules = setShippingValidationRules
window.onUseShippingForBillingChecked = onUseShippingForBillingChecked
window.setShippingBillingValidationRules = setShippingBillingValidationRules
window.firstNameFocus = firstNameFocus
window.surveyBtnEffect = surveyBtnEffect
window.surveyBlockEffect = surveyBlockEffect
